var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "get-styled-container page-container" },
    [
      _c("OutfitSwipeContainer", {
        ref: "outfitSwipe",
        on: { "swap-product": _vm.setSwapProduct }
      }),
      _vm._v(" "),
      _c("shop-items", {
        attrs: {
          outfitCurrent: _vm.outfitCurrent,
          showShopItems: _vm.showShopItems
        },
        on: { "swap-product": _vm.setSwapProduct }
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showSwapProduct
            ? _c("swap-item", { attrs: { product: _vm.swapProduct } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9335a88e", { render: render, staticRenderFns: staticRenderFns })
  }
}